module.exports = __webpack_public_path__ + "static/HelveticaNeueLTPro-BdCn-55a7e032702db215d1cf85095f586f0b.woff2";